import { combineReducers } from "redux";
import global from "./global/reducers";
import auth from "./auth/reducers";
import master from "./master/reducer";

export default combineReducers({ global, auth, master });
